import React, { useContext } from "react";
import { Link } from "react-router-dom";

import { Context } from "./../Auth.Context";
import { translate } from "./../helpers/intl_helpers";

export default function SideBar() {

    const [authDetails] = useContext(Context);

    return (
        <>
            <section className="btm_sec max-zIndex">

                <div className="menu_container">

                    <div className="navbar-fostrap">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>

                    <nav className="header_navigation">

                        <div className="menu_title">
                            Menu
                        </div>

                        <ul className="menu close">

                            {authDetails && authDetails._id ? (
                                <>
                                    <li>
                                        <Link to="/customer">
                                            <i className="bi bi-house-door-fill"></i>
                                            <span>{translate("sidebar.dashboard")}</span>
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to="/customer/start-project">
                                            <i className="bi bi-plus-circle-fill"></i>
                                            <span>{translate("dashboard.start_project")}</span>
                                        </Link>
                                    </li>

                                    {!authDetails.parent_id && (
                                        <li>
                                            <Link to="/customer/sub-user">
                                                <i className="bi bi-people-fill"></i>
                                                <span>{translate("sidebar.manage_sub_user")}</span>
                                            </Link>
                                        </li>
                                    )}
                                </>
                            ) : (
                                <>
                                    <li>
                                        <Link to="/login">
                                            <i className="bi bi-box-arrow-in-right"></i>
                                            <span>Login</span>
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to="/sign-up">
                                            <i className="bi bi-person-plus-fill"></i>
                                            <span>Sign Up</span>
                                        </Link>
                                    </li>
                                </>
                            )}

                            <li>
                                <Link to="/cms/design-guide">
                                    <i className="bi bi-palette-fill"></i>
                                    <span>{translate("dashboard.design_guide")}</span>
                                </Link>
                            </li>

                            <li>
                                <Link to="/cms/project-care">
                                    <i className="bi bi-folder2-open"></i>
                                    <span>{translate("dashboard.project_care")}</span>
                                </Link>
                            </li>

                            <li>
                                <Link to="/cms/customer-care">
                                    <i className="bi bi-headset"></i>
                                    <span>{translate("dashboard.customer_care")}</span>
                                </Link>
                            </li>

                        </ul>

                    </nav>

                </div>

            </section>
        </>
    );
}